/**
 * This model is shared by Generic and Dropdown button views. Not all
 * attributes are required by either implementation.
 */

import Brace from "backbone.brace";
import RoleValidator from "../mixins/models/role-validator";

const Model = Brace.Model.extend({
  mixins: [RoleValidator],

  namedAttributes: {
    label: String,
    icon: String,
    title: String,
    attributes: Object,
    displayFn: Function,
    eventName: String,
    action: String,
    datasource: String,
    data: Object,
    className: String,
  },
});

export { Model as default };
